export var languages = [
    {
        name: 'DEUTSCH',
        code: 'de'
    },
    {
        name: 'ENGLISH',
        code: 'en'
    }
]

export const strings = {
    'de': {
        'de': 'DEUTSCH',
        en: 'ENGLISH',
        'Suchen Sie den Weg?': 'Suchen Sie den Weg?',
        'Starten Sie hier die Navigation zu über 300 Shops': 'Starten Sie hier die Navigation zu über 180 Shops',
        'suche': 'suche',
        'übersicht' : 'übersicht',
        'Die ganze Shoppingcity auf einen Blick' : 'Die ganze ShoppingCity auf einen Blick',
        'neu':'neu',
        'neue':'neue',
        'von' : 'von',
        'nach Branchen' :'nach Branchen',
        'je Haus' : 'je Haus',
        'haus':'haus',
        'Übersicht' : 'Übersicht',
        'Ebene' : 'Ebene',
        'Wegbeschreibung' : 'Wegbeschreibung',
        'Servicepoints Anzeigen' : 'Servicepoints anzeigen',
        'Neu Laden' : 'Neu Laden',
        'Was dürfen wir für dich finden?' : 'Was dürfen wir für Sie finden?',
        'SUCHBEGRIFF EINGEBEN' : 'SUCHBEGRIFF EINGEBEN',
        'searchMoreLetters' : 'Bitte 2 oder mehr Buchstaben eingeben',
        'noshops' : 'Keine Shops gefunden',
        emptySearch1 : 'Achten Sie darauf, dass alle Wörter richtig geschrieben sind',
        emptySearch2 : 'Versuchen Sie andere Suchbegriffe',
        nothingFound: 'Opps – nichts gefunden',
        'Bleiben Sie im haus': 'Bleiben Sie in Haus',
        servicesHeadline: 'Unsere Services',
        servicesText: 'In über 180 Shops gustieren Sie nach Lust und Laune und genießen ein einmaliges Shoppingerlebnis.',
        WBTG: 'Wechseln Sie in die Ebene %level',
        WBTG2: ', gehen Sie weiter ins Haus %house',
        WBTG3: ' und bleiben Sie in Haus %house',
        WBTG4: ' und wechseln Sie mit dem Lift in die Ebene 3',
        WBMM: ' und wechseln Sie in die Ebene 3',
        WBLC: ' und wechseln Sie die Ebene',
        WBLN: 'Starten Sie %dir und gehen Sie ins Haus %house',
        WBN: 'geradeaus',
        WBE: 'rechts',
        WBS: 'rückwärts',
        WBW: 'links',
        starten: 'STARTEN',
        nonewshops: 'Aktuell haben wir keine neuen Shops dazubekommen.<br> Aber sehen Sie sich doch einfach in einem unserer 180 Shops um:'

    },
    'en': {
        'de': 'GERMAN',
        en: 'ENGLISH',
        'Suchen Sie den Weg?': 'Looking for the way?',
        'Starten Sie hier die Navigation zu über 300 Shops': 'Start here to navigate to over 180 shops',
        'suche': 'search',
        'übersicht': 'overview',
        'Die ganze Shoppingcity auf einen Blick' : 'The whole ShoppingCity in one view',
        'neue' : 'new',
        'neu' : 'new',
        'vonc': 'from',
        'nach Branchen' :'by categories',
        'je Haus' : 'by house',
        'haus':'house',
        'Übersicht' : 'Overview',
        'Ebene' : 'level',
        'Wegbeschreibung' : 'Directions',
        'Servicepoints Anzeigen' : 'Show service points',
        'Neu Laden' : 'Reload',
        'Was dürfen wir für dich finden?' : 'What can we find for you?',
        'SUCHBEGRIFF EINGEBEN' : 'Search term',
        'searchMoreLetters' : 'Please enter 2 or more letters',
        'noshops' : 'No shops found',
        emptySearch1 : 'Please make sure that all words are spelled correctly',
        emptySearch2 : 'Try another search term',
        nothingFound: 'Oops – nothing found',
        'Bleiben Sie im haus': 'Remain in house',
        servicesHeadline: 'Our Services',
        servicesText: 'Check out more than 180 shops and enjoy a unique shopping experience.',

        WBTG: 'Go to level %level',
        WBTG2: ', go to house %house ',
        WBTG3: ' and remain in house %house',
        WBTG4: ' and use the lift to reach level 3',
        WBMM: ' and change to level 3',
        WBLC: ' and change levels',
        WBLN: 'Begin %dir and go to house %house',
        WBN: 'straight ahead',
        WBE: 'right',
        WBS: 'backwards',
        WBW: 'links',
        starten: 'START',
        nonewshops: 'We currently do not have any new shops.<br> But take a look around in one of our other 180 shops:'

    }

}